import React from 'react'
import Image from '../parts/image'

const SocialLinks = ({ social, labels, className, iconClassName, display }) => {

  function SocialLink(data) {
    if (!display || display.includes(data.data.name)) {
      if (data.data.icon !== null) {
        return (
          <a
            key={`socialLink-${data.data?.name}`}
            href={data.data.link}
            className={`${iconClassName ? iconClassName : ''}`}
            target="_blank"
            rel="noreferrer"
          >
            <div className="social-link max-w-[100px] flex justify-center items-center">
              <Image
                media={data.data.icon}
                className="social-icon pointer-events-none relative z-10 block fill-white text-white"
              />
            </div>
            {
              labels && (
                <span>{data.data.name}</span>
              )
            }
          </a >
        )
      } else {
        return (
          <a
            key={`socialLink-${data.data?.name}`}
            href={data.data.link}
            className="flex h-14 w-14 items-center justify-center rounded-full bg-gray-400 hover:bg-secondary"
            target="_blank"
            rel="noreferrer"
          >
            {data.data.name}
          </a>
        )
      }
    }
    return ''
  }

  return (
    <div className={className}>
      {social.map(socialLink => (
        <SocialLink
          data={socialLink}
          key={`socialLink-${socialLink?.name}-${labels ? 'labels' : 'icon'}`}
        />
      ))}
    </div>
  )
}

export default SocialLinks
